__turbopack_context__.v({
  "notification-preference-toggle__alert": "W_WUrG_notification-preference-toggle__alert",
  "notification-preference-toggle__content": "W_WUrG_notification-preference-toggle__content",
  "notification-preference-toggle__header": "W_WUrG_notification-preference-toggle__header",
  "notification-preference-toggle__title": "W_WUrG_notification-preference-toggle__title",
});
